import React from 'react';
import { StringColumn, CustomColumn, CategoricalColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';
import _toLower from 'lodash/toLower';
import _startsWith from 'lodash/startsWith';
import dayjs from 'dayjs';

import { GLOBAL_THEME } from 'commons-ui';

export const COL_NAMES = {
	ticketId: 'ticketId',
	category: 'category',
	subCategory: 'subCategory',
	description: 'description',
	status: 'status',
	createdAt: 'createdAt',
	closedAt: 'closedAt'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Ticket Id',
		maxWidth: 300,
		mapDataToValue: (data: any) => (data[COL_NAMES.ticketId] || '').toString(),
		renderCell: (params: any) => {
			const { value } = params;

			return <div>{value}</div>;
		},
		textQueryFilter: (textQuery: string, data: string): boolean => {
			return _startsWith(data, `${textQuery}`);
		}
	}),
	CategoricalColumn({
		title: 'Category',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.category] || ''
	}),
	CategoricalColumn({
		title: 'Sub-Category',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.subCategory] || ''
	}),
	CustomColumn({
		title: 'Description',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.description],
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 30) {
				descriptionCompress = `${value.substr(0, 30)}...`;
			} else {
				descriptionCompress = value;
			}
			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	CustomColumn({
		title: 'Status',
		mapDataToValue: (data: any) => data[COL_NAMES.status],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			let backgroundColor = GLOBAL_THEME.Colors.white;
			const lowerCaseValue = _toLower(value);
			if (lowerCaseValue === 'open') {
				backgroundColor = GLOBAL_THEME.Colors.cellYellow;
			} else if (lowerCaseValue === 'closed') {
				backgroundColor = GLOBAL_THEME.Colors.cellGreen;
			} else if (lowerCaseValue === 'new') {
				backgroundColor = GLOBAL_THEME.Colors.cellGrey;
			} else if (lowerCaseValue === 'pending') {
				backgroundColor = GLOBAL_THEME.Colors.cellRed;
			} else if (lowerCaseValue === 'onhold') {
				backgroundColor = GLOBAL_THEME.Colors.cellOrange;
			}
			return (
				<div
					className={css({
						backgroundColor,
						height: '100%',
						width: '100%',
						paddingLeft: '10px'
					})}>
					{value}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Created at',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.createdAt] ? dayjs(new Date(data[COL_NAMES.createdAt])).format('DD-MM-YYYY hh:mm A') : ''
	}),
	StringColumn({
		title: 'Closed at',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.closedAt] ? dayjs(new Date(data[COL_NAMES.closedAt])).format('DD-MM-YYYY hh:mm A') : ''
	})
];
